<div class="chat-details-info" [ngClass]="{'group': isGroupChat}">
  <div class="chat-details-info-container" *ngIf="currentChat && (messengerService.isLoading$ | async) === false">
    <div class="back-btn" *ngIf="(messengerService.isShowList | async) === false">
      <button mat-icon-button (click)="handleBackToList()">
        <mat-icon svgIcon="arrow_back"></mat-icon>
      </button>
    </div>

    <div class="chat-avatar-container">
      <div class="chat-avatar">
        <ng-container *ngIf="isGroupChat; else personal">
          <div class="chat-avatar-users">
            <div class="chat-avatar-users-item" *ngFor="let user of currentChat?.users.slice(0, 4); trackBy: trackBy">
              <lin-avatar [source]="user.picture" [name]="user.name" [surName]="user.surname" [size]="AvatarSize.group"> </lin-avatar>
            </div>
          </div>
        </ng-container>
        <ng-template #personal>
          <lin-avatar
            [source]="avatarPersonal?.picture"
            [name]="avatarPersonal?.name"
            [surName]="avatarPersonal?.surname"
            [size]="AvatarSize.mds"
          >
          </lin-avatar>
        </ng-template>
      </div>
      <div class="user-status" *ngIf="!isGroupChat">
        <div class="status" [ngClass]="{ 'online': avatarPersonal?.networkStatus }"></div>
      </div>
    </div>

    <div class="chat-details-info-title">
      <div class="h2">{{ currentChat?.isIndividual ? avatarPersonal?.fullName : currentChat?.name || chatName }}</div>
      <div class="subheading-2">
        {{ currentChat?.isIndividual ? getNetworkStatusTitle(avatarPersonal) : currentChat?.users.length + ' participants' }}
      </div>
    </div>
  </div>
</div>

<button *ngIf="isMyChat" mat-icon-button (click)="handleAddToChat()">
  <mat-icon svgIcon="info"></mat-icon>
</button>

<h4 *ngIf="!isMyChat && currentChat && (messengerService.isLoading$ | async) === false" class="read-only">
  {{ 'CLIENT.MESSENGER.CHAT_DETAILS.READ_ONLY' | translate }}
</h4>

<div *ngIf="(messengerService.isLoading$ | async) === false" class="chat-details-delete-container">
  <button *ngIf="!isMyChat; else outer" mat-icon-button (click)="handleJoinChat()">
    <mat-icon svgIcon="send"></mat-icon>
  </button>
  <ng-template #outer>
    <button mat-icon-button (click)="handleLeaveChat()">
      <mat-icon svgIcon="output"></mat-icon>
    </button>
  </ng-template>
</div>
